export default "__VITE_ASSET__hK71SRfysxqxFJEij39IfQ__"